import { useState } from "react";

const useCollection = <T extends object | string | number>(
  defaultValues: T[] = []
) => {
  const [items, setItems] = useState<T[]>(defaultValues);

  const add = (item: T) => {
    setItems((prevItems) => [...prevItems, item]);
  };

  const addIfNotExists = (item: T) => {
    const exists = items.some((existingItem) =>
      typeof item === "object" && typeof existingItem === "object"
        ? "id" in existingItem && "id" in item && existingItem.id === item.id
        : existingItem === item
    );

    if (!exists) {
      add(item);
    }
  };

  const addIfNotExistsOrReplace = (item: T) => {
    setItems((prevItems) => {
      const existingIndex = prevItems.findIndex((existingItem) =>
        typeof item === "object" && typeof existingItem === "object"
          ? "id" in existingItem && "id" in item && existingItem.id === item.id
          : existingItem === item
      );

      if (existingIndex !== -1) {
        // Replace existing item
        return prevItems.map((existingItem, index) =>
          index === existingIndex ? item : existingItem
        );
      }

      // Add new item
      return [...prevItems, item];
    });
  };

  const remove = (item: T) => {
    setItems(
      items.filter((existingItem) =>
        typeof item === "object" && typeof existingItem === "object"
          ? !(
              "id" in existingItem &&
              "id" in item &&
              existingItem.id === item.id
            )
          : existingItem !== item
      )
    );
  };

  const reset = () => {
    setItems(defaultValues);
  };

  return {
    add,
    addIfNotExists,
    addIfNotExistsOrReplace,
    items,
    remove,
    reset,
  };
};

export default useCollection;
